import { render, staticRenderFns } from "./OnboardingImageTemplate.vue?vue&type=template&id=7d9e80aa&scoped=true&"
import script from "./OnboardingImageTemplate.vue?vue&type=script&lang=js&"
export * from "./OnboardingImageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingImageTemplate.vue?vue&type=style&index=0&id=7d9e80aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9e80aa",
  null
  
)

export default component.exports